var _module = require('./index');

_module.directive('percentNgModel', [
    '$log',

    function percentNgModel($log) {
        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {},
            link: function percentNgModelLink($scope, $elem, $attrs, ngModelCtrl) {
                ngModelCtrl.$formatters.push(filterNgModelFormatter);
                ngModelCtrl.$parsers.push(filterNgModelParser);

                // Listeners
                $elem.on('focus', function onChange(e) {
                    ngModelCtrl.$setViewValue(filterNgModelParser($elem.val()), 'focus');
                    ngModelCtrl.$render();
                });

                $elem.on('blur', function onChange(e) {
                    ngModelCtrl.$setViewValue(filterNgModelFormatter($elem.val()), 'blur');
                    ngModelCtrl.$render();
                });

                // Functions
                function filterNgModelFormatter(modelValue) {
                    var value = String(angular.isDefined(modelValue) ? modelValue : '0').replace(/([^0-9\.])/gi, '');

                    if(~value.indexOf('.')) {
                        value = value.substr(0, value.lastIndexOf('.') + 3);
                    }

                    value = parseFloat(value);

                    return value ? value + '%' : undefined;
                }

                function filterNgModelParser(viewValue) {
                    var value =  String(angular.isDefined(viewValue) ? viewValue : '0').replace(/([^0-9\.])/gi, '');

                    if(~value.indexOf('.')) {
                        value = value.substr(0, value.lastIndexOf('.') + 3);
                    }

                    return parseFloat(value) || undefined;
                }
            }
        };
    }
]);

